var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCrosshair = function SvgIconCrosshair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 1.875a1 1 0 1 0-2 0v.928A9.254 9.254 0 0 0 2.803 11h-.928a1 1 0 1 0 0 2h.928A9.254 9.254 0 0 0 11 21.197v.928a1 1 0 1 0 2 0v-.928A9.254 9.254 0 0 0 21.197 13h.928a1 1 0 1 0 0-2h-.928A9.254 9.254 0 0 0 13 2.803zM18.75 11h.432A7.254 7.254 0 0 0 13 4.818v.432a1 1 0 1 1-2 0v-.432A7.254 7.254 0 0 0 4.818 11h.432a1 1 0 1 1 0 2h-.432A7.254 7.254 0 0 0 11 19.182v-.432a1 1 0 1 1 2 0v.432A7.254 7.254 0 0 0 19.182 13h-.432a1 1 0 1 1 0-2"
  }))));
};
export default SvgIconCrosshair;